import { Injectable, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppModule } from "app/app.module";
import { Location } from '@angular/common';
import { Subscription } from "rxjs/Subscription";
import * as _ from 'underscore';
import { BaseController } from ".";
import { BaseService } from "../services";
import { APPCONFIG } from '../config';

@Injectable()
export class DetalheBaseController extends BaseController {
    modelLoaded: EventEmitter<any> = new EventEmitter();
    type: string;
    showForm: boolean = false;
    _route: ActivatedRoute;
    _location: Location;
    subGet: Subscription;
    subPut: Subscription;
    subPost: Subscription;
    id: any;
    constructor(_route: ActivatedRoute, private _service: BaseService) {
        super(_service)
        this._route = _route;
        this.type = this._route.snapshot.data['type'];
        this._location = AppModule.injector.get(Location);
    }

    ngOnInit() {
        if (this.type == "edit" || this.id != undefined) {
            let id = this._route.snapshot.params['id'] || this.id;
            this.subGet = this.service.get(this.service._api, id).subscribe(result => {
                this.model = result;
                this.showForm = true;
                this.modelLoaded.emit({});
            });
        }
        else {
            this.showForm = true;
        }
    }

    public salvar(form) {
        let type = this._route.snapshot.data['type'];
        if (type == "edit") {
            form.id = this.model.id;
            this.subPut = this.service.putId(this.service._api, this.model.id, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        } else {
            this.subPost = this.service.post(this.service._api, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        }
    }

    public gravaLog(_method, _service, _boletoId) {        
        var modelLog = {            
            DevedorId: 0,  
            DevedorNome: "",  
            IP: "",  
            URL: APPCONFIG.server + this._service._language + "/api/logsistema/",              
            Verb: "GET",  
            Token: "",  
            Method: _method,  
            RequestBody: "",  
            ResponseBody: "",  
            StatusCode: 200,  
            RequestStart: new Date(),  
            RequestEnd: new Date(),  
            Duration: 0,  
            Json: "", 
            BoletoId: "" 
        };
        var _currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));       
        modelLog.DevedorId = _currentUser.devId;
        modelLog.DevedorNome = _currentUser.nome;
        modelLog.Token = _currentUser.token;       
        modelLog.BoletoId = _boletoId;
        modelLog.Json = JSON.stringify(modelLog);
        modelLog.RequestBody = JSON.stringify(modelLog);        
        _service.post("/api/logsistema/", modelLog).subscribe(result => {            
        });
    }

    carregarLoading() {
        this._loading.carregar();
    }

    fecharLoading() {
        this._loading.fecharTodos();
    }

    ngOnDestroy() {
        if (this.subGet) this.subGet.unsubscribe();
        if (this.subPut) this.subPut.unsubscribe();
        if (this.subPost) this.subPost.unsubscribe();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/helpers/detalhe.base.controller.ts